import _ from 'lodash';
import roles from 'app/validators/roles';
import { setDirtyForm } from 'app/actions/dirty-forms.actions';
import { checkAccess } from 'app/actions/app.actions';
import viewLspModalTemplate from './view-lsp-as-this-user-confirm-modal.html';
import authenticateUserModalTemplate from './authenticate-user-confirm-modal.html';
import accountDetailsTemplate from './account-details.html';
import deleteUserModalTemplate from './delete-user-confirm-modal.html';

const CHAIN_HEAD = 3;

const mapStateToThis = ({ session, config }) => {
  const { isAdmin, locale } = session;
  const { lowCostCarriers, phoneMask, phoneLength, maxFirstNameLength, maxLastNameLength, maxEmailLength } = config;

  return {
    locale,
    isAdmin,
    lowCostCarriers,
    phoneMask,
    phoneLength,
    maxFirstNameLength,
    maxLastNameLength,
    maxEmailLength,
  };
};

const mapDispatchToThis = {
  setDirtyForm,
  checkAccess,
};

// eslint-disable-next-line no-undef
@Inject('$ngRedux', 'Responsive', 'gettextCatalog')
class AccountDetailsController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  $onInit() {
    this.DIRTY_FORM = 'editAccount';
    this.canDeleteUser = this.checkAccess('user.canDelete');
    this.disabledInfo = this.gettextCatalog.getString('You do not have the required permissions to edit this user`s information.');
    this.canResetPassword = this.checkAccess('user.resetAccountPassword');
    this.canShowLoginAsThisUser = this.isAdminUser() ? this.checkAccess('user.viewAsAdmin') : this.checkAccess('user.canLoginAsThisUser');
  }

  $onDestroy() {
    this.unsubscribe();
  }

  onUpdatePersonalData(form) {
    form.$setSubmitted();
    if (!form.$valid) return;

    this.updatePersonalData().then(() => {
      this.setDirtyForm(this.DIRTY_FORM, false);
      form.$setPristine();
    });
  }

  showAuthenticateUserConfirm() {
    this.authenticateUser({
      template: authenticateUserModalTemplate,
      user: this.model.user.editAccount,
    });
  }

  showLoginAsConfirm() {
    return this.loginAs({ template: viewLspModalTemplate, form: this.form });
  }

  onDeleteUser() {
    this.deleteUser({ template: deleteUserModalTemplate });
  }

  isSecondary() {
    return roles.SECONDARY_USER_ROLES.indexOf(_.get(this.model, 'user.editAccount.userClass')) !== -1;
  }

  isSecondaryOrChainHead() {
    return this.isSecondary() || _.get(this.model, 'user.editAccount.retailer.retailerType') === CHAIN_HEAD;
  }

  isAdminUser() {
    return roles.ADMIN_ROLES.indexOf(_.get(this.model, 'user.editAccount.userClass')) !== -1;
  }

  isRetailerGroup() {
    return roles.RETAILER_GROUP_ROLES.indexOf(_.get(this.model, 'user.editAccount.userClass')) !== -1;
  }

  isRoleVisible() {
    return !this.isAdminUser() && !this.isRetailerGroup();
  }

  isSmsConsentVisible() {
    return !this.isAdminUser() && !this.isRetailerGroup();
  }
}

export default class AccountDetailsComponent {
  constructor() {
    this.template = accountDetailsTemplate;
    this.controller = AccountDetailsController;
    this.bindings = {
      model: '<',
      config: '<',
      canShowResendActivationEmail: '&',
      resendActivationEmail: '&',
      canShowAuthenticateUser: '&',
      authenticateUser: '&',
      canShowChangePrimaryUserBtn: '&',
      accountInactive: '<',
      canUpdateData: '<',
      canCompleteRegistration: '<',
      canShowLoginAsThisUser: '&',
      canEditAccountDetails: '<',
      canShowRetailerFields: '&',
      canChangeUserStatus: '&',
      updatePersonalData: '&',
      loginAs: '&',
      deleteUser: '&',
    };
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/user/components/edit-account/components/account-details/account-details-component.js